import client from '@stores/apollo'
import { IAdminSearchResult } from '@api/types'
import { SearchType } from 'components/EmployeeManagement/hooks/useAdminSearch'
import { adminMapSearch } from './queries'

interface Payload {
  data: {
    viewer: {
      company: {
        search: IAdminSearchResult
      }
    }
  }
}

export default function search({
  query,
  after,
  apId,
  unseated,
  location,
  searchType,
}: {
  query: string
  searchType: SearchType
  apId: string
  after?: string
  orderBy?: string
  unseated?: boolean
  location?: boolean
}): Promise<IAdminSearchResult> {
  const variables = {
    query,
    assignmentPlanId: apId,
    unseated,
    location,
    fetchEmployeeBooking: false,
    searchType,
    after: after || undefined,
  }

  return client.gql.query({ query: adminMapSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: { search },
        },
      },
    }: Payload) => search
  )
}
